import { subjects as integrationSubjects } from '@sopranodesign/pulse-integrations';
import { subjects as importSubjects } from '@sopranodesign/pulse-import';

const composers = [
  integrationSubjects.composers.integration,
  integrationSubjects.composers.lookup,
  importSubjects.composers.section
];

export default composers;
